<template>
  <div>
    <open-with-option-dialog
        :show="showAttachOptionsDialog"
        @onDismiss="showAttachOptionsDialog=false"
        @onOptionSelected="attachFileInPartnerApp"
    ></open-with-option-dialog>

    <button-with-image
      class="horizontal-center"
      :text="text"
      :size="size"
      :disabled="disabled"
      :emit-on-disabled="true"
      :image-src="attachImageDesSrc"
      :enabled-btn-style="enabledBtnStyle"
      :enabled-text-style="enabledTextStyle"
      :disabled-button-style="disabledButtonStyle"
      :disable-text-style="disableTextStyle"
      @onButtonClicked="onAttachFileClicked"
      ></button-with-image>

    <weex-text
      class="text-align-center text-color-black font-size-sm-base"
      v-if="showAttachDescription && attachDescription"
      v-html="attachDescription"
      ></weex-text>

    <input
      v-show="false"
      type="file"
      :id="fileAttachButtonId"
      v-on:change="handleAttachedFileFromWeb"
      @disappear="true"
      style="visibility: hidden"
      />
  </div>
</template>

<script>
  import ButtonWithImage from "./ButtonWithImage";
  import EzUtils from '../../utils/EzUtils';
  import OpenWithOptionDialog from "@/components/dialogs/OpenWithOptionDialog";
import FileCompression from "../../utils/FileCompression";

  export default {
    name: "FileAttachButton",
    components: { ButtonWithImage, OpenWithOptionDialog },
    props: {
      text: {
        type: String,
        required: true,
        default: "Attach"
      },

      showAttachDescription: {
        type: Boolean,
        default: false
      },

      attachDescription: {
        type: String,
        default: ""
      },

      fileAttachButtonId: {
        type: String,
        required: true
      },

      attachImageDesSrc: {
        type: String,
        default: ''
      },

      disabled: {
        type: Boolean,
        default: false
      },

      fileAttachmentSize: {
        type: Number,
        default: 1
      },

      allowFromCamera: {
        type: Boolean,
        default: true
      },

      allowFromGallery: {
        type: Boolean,
        default: true
      },

      size: {
        type: String,
        default: "medium"
      },

      enabledBtnStyle: {
        type: Object,
        default: function () {
          return {
            backgroundColor: "#ffffff",
            "border-width": "1px",
            "border-color": "gray",
            "border-style": "solid"
          }
        }
      },

      disabledButtonStyle: {
        type: Object,
        default: function () {
          return { 'backgroundColor': '#D9D9D9' }
        }
      },

      enabledTextStyle: {
        type: Object,
        default: function () {
          return { color: '#000000' }
        }
      },

      disableTextStyle: {
        type: Object,
        default: function () {
          return { 'color': '#000000' }
        }
      },

      compressFile: {
        type: Boolean,
        default: true,
        required: false
      },
    },

    data: () => ({
      showAttachOptionsDialog: false
    }),

    methods: {
      onAttachFileClicked() {
        this.$emit("attachFilesClicked");
        if (!this.disabled) {
          this.attachFile();
        }
      },

      attachFileInPartnerApp(option) {
        this.showAttachOptionsDialog = false;
        if (window.AndroidJsInterface) {
          window.AndroidJsInterface.clearImage();
          if (EzUtils.areEqualString("Camera", option, true)) {
            window.AndroidJsInterface.openCamera();
          } else {
            window.AndroidJsInterface.openGallery();
          }
          this.originalPoll(this.filesAttached);
        }
      },

      attachFile() {
        if (window.AndroidJsInterface) {
          //Airtel related changes
          this.attachFileInPartnerApp("Gallery")
        } else {
          document.getElementById(this.fileAttachButtonId).click();
        }
      },

      handleAttachedFileFromWeb(event) {
        this.filesAttached(event.target.files);
        document.getElementById(this.fileAttachButtonId).value = "";
      },

      filesAttached(files) {
        //Airtel related changes
        if(window.AndroidJsInterface){
          const base64 = window.AndroidJsInterface.getImage();
          let file = EzUtils.getFileFromBaseSixtyFour(base64);
          files = [];
          files.push(file)
        }
        if(files && files.length > 0 && files[0]){
          if (this.compressFile && FileCompression.checkIfValidImageFiles(files)) {
            FileCompression.compressMultipleFiles(files).then(compressedFiles => {
              this.$emit("filesAttached", { files: compressedFiles });
            })
          } else {
            this.$emit("filesAttached", { files: files });
          }
          
        }
      },

      originalPoll(callback) {
        let startTime = new Date();
        function checkCondition() {
          let currentTime = new Date();
          let timeDiff = EzUtils.timeDifferenceInMinute(currentTime,startTime)
          let result = window.AndroidJsInterface.getImage();
          if (!result && timeDiff<2) {
            setTimeout(checkCondition, 500);
          } else {
            callback();
          }
        }
        checkCondition();
      },
    },
  }
</script>

<style
  scoped
  src="../../assets/style/base.css"></style>
